/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


export default class
{
  constructor ()
  {
    this.collection = [];
  }


  push (source)
  {
    this.collection.push(source);
  }


  getMaxValue (user, type)
  {
    let value = 0;

    for (const attribute of this.collection)
    {
      if (!attribute.isSatisfiedBy(user, type))
      {
        continue;
      }

      if (value === 0 || attribute.getValue() > value)
      {
        value = attribute.getValue();
      }
    }

    return value;
  }


  getMinValue (user, type)
  {
  let value = 0;

    for (const attribute of this.collection)
    {
      if (!attribute.isSatisfiedBy(user, type))
      {
        continue;
      }

      if (value === 0 || attribute.getValue() < value)
      {
        value = attribute.getValue();
      }
    }

    return value;
  }


};
